import React from 'react';
import Search from './Search';
import TablaCliente from './TablaCliente';
import TablaProforma from './TablaProforma';
import Breadcrumb from './Breadcrumb';
import Pills from './Pills';
import Filters from './Filters';

const FirstStep = props => (
  <div>
    <Breadcrumb
      stillSearch={props.stillSearch}
      goToClients={props.goToClients}
      clientName={props.clientName}
      searchByProforma={props.searchByProforma}
    />
    <Pills proformas={props.selectedProform} unselectProforma={props.unselectProforma} />
    {
      props.stillSearch &&
        <Search
          searchInput={props.searchInput}
          searchOption={props.searchOption}
          onChangeValue={props.onChangeValue}
          onChangeSelect={props.onChangeSelect}
          search={props.search}
        />
    }
    {
      props.clientTable &&
        <TablaCliente
          clientes={props.clientes}
          paginateClient={props.paginateClient}
          showClientProform={props.showClientProform}
        />
    }
    {
      !props.stillSearch &&
        <Filters
          companias={props.companias}
          companyFilter={props.companyFilter}
          areasVenta={props.areasVenta}
          areaVentaFilter={props.areaVentaFilter}
          vendedores={props.vendedores}
          vendedorName={props.vendedorName}
          onCheck={props.onCheck}
          searchByFilter={props.searchByFilter}
          fetchVendedores={props.fetchVendedores}
          onChangeVendedores={props.onChangeVendedores}
          onSelectVendedores={props.onSelectVendedores}
          searchByVendedor={props.searchByVendedor}
        />
    }
    {
      props.proformTable &&
        <TablaProforma
          proformas={props.proformas}
          selectedProform={props.selectedProform}
          selectProform={props.selectProform}
          paginateProform={props.paginateProform}
          fichaVentaDeProformaQueYaSeAsigno={props.fichaVentaDeProformaQueYaSeAsigno}
          searchFDV = {props.searchFDV}
          nroProforma = {props.nroProforma}
        />
    }
    <div className='modal-actions'>
      <button
        type='submit'
        className='btn btn-primary pull-right'
        onClick={props.nextStep}
        disabled={props.selectedProform.length < 1 }
      >
        Siguiente
      </button>
    </div>
  </div>
);

export default FirstStep;



// WEBPACK FOOTER //
// ./src/pages/modals/NuevaFichaVenta/FirstStep.js